module.exports = __webpack_public_path__ + "assets/analytics-2.844381a0.svg";